import React from 'react'

const GestionTiers = () => {
  return (
    <div>GestionTiers</div>
  )
}

export default GestionTiers